import React, { FCC } from 'react';

export const InputError: FCC<{ message: string; id: string }> = (props) => {
  const { message, id } = props;
  return (
    <div id={id} className="help-block">
      {message}
    </div>
  );
};

export default InputError;
